import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { validateNumber, getNumberErrorMsg } from '../components/utility';

const advancedBookConst = {
  min: 0,
  max: 330,
  isInteger: true,
};

export const validateAdvancedBookingDays = ({
  value, min = advancedBookConst.min, max = advancedBookConst.max, isInteger = advancedBookConst.isInteger,
}) => validateNumber({
  value, min, max, isInteger, extra: [],
});
export const getValidateAdvancedBookingDaysErrorMsg = ({
  code, i18n, min = advancedBookConst.min, max = advancedBookConst.max,
}) => {
  switch (code) {
    default:
      return getNumberErrorMsg({
        code, i18n, min, max,
      });
  }
};

export const isABWOverlapCal = (dt1, dt2) => {
  const start1 = Number(dt1.minimumDays);
  const end1 = Number(dt1.maximumDays);
  const start2 = Number(dt2.minimumDays);
  const end2 = Number(dt2.maximumDays);
  let [flag1, flag2, flag3] = [true, true, true];
  if (decimal.isValid(dt1.minimumDays) && decimal.isValid(dt1.maximumDays)) {
    flag1 = start1 <= end1;
  }
  if (decimal.isValid(dt2.minimumDays) && decimal.isValid(dt2.maximumDays)) {
    flag2 = start2 <= end2;
  }
  if (decimal.isValid(dt1.maximumDays) && decimal.isValid(dt2.minimumDays)) {
    flag3 = end1 < start2;
  }
  if (!flag1 || !flag2) {
    return 'minimum_greater_than_maximum';
  }
  if (!flag3) {
    return 'adjust_settings';
  }
  return '';
};

